import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import { useState } from 'react';
import DeleteCancel from '../../atoms/buttons/DeleteCancel';
import { invokePostService } from "../../../store/global/actions";
import { getDetailsFromUrl } from '../../../services/blueprint';


export default function DeleteSimulationTransaction({ element, onClose, onCompletion }) {

    const dispatch = useDispatch();
    const currentUrl = window.location.href;
    const { entityId } = getDetailsFromUrl()

    const [isDeleting, setIsDeleting] = useState(false);

    const onDelete = () => {

        setIsDeleting(true)
        dispatch(invokePostService('deleteSimulationTransaction', {testsuiteId: entityId}, [element.testcase_id, element.simulation_transaction_id]))
            .then((response) => {
                if (response.status) {
                    onCompletion("Simulation transaction", "delete")
                }
                setIsDeleting(false)
            })
    }

    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography variant="h6" >Delete</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to delete the Transaction ? </Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onDelete={onDelete} onCancel={onClose} disableButton={isDeleting} content={isDeleting ? 'Deleting..' : 'Delete'} />
            </Grid>


        </Grid>
    )
}
